import * as React from "react";
import { connect } from "react-redux";
import {
  getStudentTaskDeliver,
  addDeliveryFile,
  submitTask,
  checkStatusTask,
  initStatusTask,
  removeDeliveryFile,
  getComments,
} from "../../../actions/Action_Student";
import "../../QuillStyles.scss";
import Select from "react-select";
import "../../../../../src/app/formelements.scss";
import OneDrivePicker from "../../shared/OneDrivePicker";
import ProgressList from "./ProgressList";
import ReactTooltip from 'react-tooltip';
import {
  ProgressIndicator,
  ActionButton,
  Label,
  PrimaryButton,
  Icon,
  Spinner,
  SpinnerSize,
} from "office-ui-fabric-react";
import LinkForm from "./LinkForm";
// import {isDateStringBeforeToday} from '../../../utils/DateUtils';
import * as moment from 'moment';
import EvaluationFiles from "../../innleveringer/EvaluationFiles";
import { ITaskEvaluationFileInfo } from "../../../models/interfaces/ITaskEvaluationFile";
import axios from "axios";
import { EXAM_MODE, ROOT_URL, SP_HOST_URL } from "../../../actions/constants";
import { dateStringToMoment } from "../../../utils/DateUtils";
import { Button, Text } from "office-ui-fabric-react";
import FileIcon from "../../FileIcon/FileIcon";
import UploadFileForm from "../../UploadFileForm/UploadFileForm";
import { uploadTaskFiles } from "../../../services/taskService";

export interface IStudentTaskViewProps {
  events: any;
  schoolClasses: any;
  teacherstate: any;
  tasks: any;
  getStudentTaskDeliver(task: any);
  addDeliveryFile(file: any);
  submitTask(task: any);
  checkStatusTask(files: any[]);
  initStatusTask(files: any[]);
  removeDeliveryFile(file: any);
  getComments(st: any);
  studenttask: any;
  history: any;
  match: any;
  activefileurl: any;
  activefile: any;
}
export interface IStudentTaskViewState {
  showevaledit: boolean;
  showevaltext: boolean;
  studenttask: any;
  showeval: boolean;
  showdeadline: boolean;
  activefile: any;
  selectedfiles: any[];
  downloading: boolean;
  comments: any[];
  activefileurl: any;
  delivering: boolean;
  fileBeingDeleted?: number;

  // DELIVERY FILES

  dfFilesLoading: string[],
  isLoadingDeliveryFiles: boolean;

  // Used for EvaluationFiles component because React doesnt work
  isLoadingEvaluationFiles: boolean;
	evaluationFilesToUpload: any[];
	evaluationFiles: ITaskEvaluationFileInfo[];
	evaluationFilesLoading: string[];
  errorFetchingEvaluationFiles: boolean;
}

class StudentTaskView extends React.Component<
  IStudentTaskViewProps,
  IStudentTaskViewState
> {

  private inputRef = React.createRef<HTMLInputElement>();
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.state = {
      showevaledit: false,
      showevaltext: true,
      studenttask: {},
      showdeadline: false,
      showeval: true,
      activefile: this.props.activefile,
      selectedfiles: [],
      downloading: false,
      comments: [],
      activefileurl: "",
      delivering: false,
      fileBeingDeleted: null,

      // DELIVERY FILES
      dfFilesLoading: [],
      isLoadingDeliveryFiles: false,

      // EVALUATION FILES
      isLoadingEvaluationFiles: false,
      evaluationFilesToUpload: [],
      evaluationFiles: [],
      evaluationFilesLoading: [],
      errorFetchingEvaluationFiles: false
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.getStudentTaskDeliver({ Id: id }).then((ret) => {
      let studenttask = ret.payload.data;
      studenttask.DeliveryFiles.forEach((element) => {
        let veropt = [];
        if (element.VersionFiles) {
          element.VersionFiles.forEach((element) => {
            veropt.push({ value: element.WopiUrl, label: element.Name });
          });
        }
        
        element.opts = veropt;
      });
      let afurl = "";
      let af = undefined;
      if (studenttask.DeliveryFiles[0]) {
        afurl = studenttask.DeliveryFiles[0].WopiUrl;
        af = studenttask.DeliveryFiles[0];
      }
      
      this.setState({
        downloading: true,
        activefile: af,
        activefileurl: afurl,
        studenttask: studenttask,
        selectedfiles: studenttask.DeliveryFiles,
      });
      this.props.getComments(ret.payload.data).then((cmts) => {
        this.setState({ comments: cmts.payload.data });
      });
    });
  }
  

  componentWillReceiveProps(props) {
    // if (props.studenttask && props.studenttask.Id) {
    //   this.setState({
    //     studenttask: props.studenttask,
    //     selectedfiles: props.studenttask.DeliveryFiles,
    //   });
    //   props.studenttask.DeliveryFiles.forEach((element) => {
    //     let chk = [];
    //     if (element.DeliveryStatus == 5) {
    //       chk.push(element);
    //     }
    //     if (chk.length > 0) {
    //       this.props.checkStatusTask(chk);
    //     }
    //   });
    // }
  }

  /// EVALUATION FILES ///
  fetchEvaluationFiles = async (task) => {
    try {
        this.setState({isLoadingEvaluationFiles: true, errorFetchingEvaluationFiles: false});
        const res = await axios.get(`${ROOT_URL}/GetTaskEvaluationFiles${SP_HOST_URL}&taskId=${task.WsTaskID}&studentLoginName=${encodeURIComponent(task.LoginName)}`, {
            headers: {
                Authorization: localStorage.getItem('id_token')
            }
        })
        this.setState({evaluationFiles: res.data as ITaskEvaluationFileInfo[], isLoadingEvaluationFiles: false});
    }
    catch (error) {
        this.setState({errorFetchingEvaluationFiles: true, isLoadingEvaluationFiles: false});
    }
}

  wasDeliveredOnTime = () => {
    try {
      
      if (this.props.studenttask.DateDelivered) {
        if (dateStringToMoment(this.props.studenttask.Deadline).isAfter(dateStringToMoment(this.props.studenttask.DateDelivered))) {
          return true;
        }
        else {
          return false;
        }
      }
      return true;
    }
    catch (e) {
      return true;
    }
  }

  canEdit = (): boolean => {
    return ((this.props.studenttask.DeliveryStatus == 1 || this.props.studenttask.DeliveryStatus == 6 || (this.state.studenttask.WsTask.KeepOpen && this.props.studenttask.DeliveryStatus != 2)) && this.state.studenttask.DeliverStatus != 4 && (moment().isBefore(dateStringToMoment(this.state.studenttask.Deadline)) || this.state.studenttask.WsTask.DeliverAfterDeadline));
  }

  canUploadOneDriveFiles = (): boolean => {
    if (EXAM_MODE) {
      return false;
    }
    if (this.canEdit()) {
      return this.props.studenttask.WsTask.AllowOneDriveUpload;
    }
    return false;
  }

  canUploadFiles = (): boolean => {
    if (this.canEdit()) {
      return this.props.studenttask.WsTask.AllowFileUpload;
    }
    return false;
  }

  canUploadLinks = (): boolean => {
    if (EXAM_MODE) {
      return false;
    }
    if (this.canEdit()) {
      return this.props.studenttask.WsTask.AllowLinks;
    }
    return false;
  }

  hasTaskStarted = () => {
    return !this.props.studenttask.WsTask.Starttime || (this.props.studenttask.WsTask.Starttime && dateStringToMoment(this.props.studenttask.WsTask.Starttime).valueOf() <= moment().valueOf());
  }

  fileIsBeingDeleted = (id: number): boolean => {
    if (this.state.fileBeingDeleted && this.state.fileBeingDeleted === id) {
      return true;
    }
    return false;
  }

  formatExternalLink(url) {
    if (!url) return "";
    return url.startsWith("http://") || url.startsWith("https://") 
      ? url 
      : `https://${url}`;
  }

  renderAddedByTeacher = (file: any) => {
    const tooltipId: string = `addedByTeacherIcon-${file.Id}`;

    return <span style={{marginLeft: "0.5em"}}>
      <Icon data-tip data-for={tooltipId} iconName="UserOptional" className="fileAddedByTeacherIcon" />
      <ReactTooltip id={tooltipId}>
        Denne filen har blitt lagt til av lærer
      </ReactTooltip>
    </span>
  }

  renderTaskNotStarted = () => {
    return <div className="ms-Grid-row">
      <div className="ms-fontSize-xl">
        Innleveringen har ikke startet enda. 
      </div>
      <br/>
      <div className="ms-fontSize-xl">
        Åpner opp for svar {dateStringToMoment(this.props.studenttask.WsTask.Starttime).format("DD.MM.YYYY HH:mm")} 
      </div>
    </div>
  }

  renderDeleteDeliverFileButton = (item: any, loading: boolean) => {
    return (!loading) ? <ActionButton
      iconProps={{ iconName: "Delete" }}
      style={{height: '75%'}}
      onClick={async () => {
        if (!this.state.fileBeingDeleted) {
          try {
            this.setState({fileBeingDeleted: item.Id});
            const resp = await this.props.removeDeliveryFile(item);
  
            // console.log(resp);
            const ret = await this.props.getStudentTaskDeliver(this.state.studenttask);
            console.log(ret);
            let studenttask = ret.payload.data;
            let afurl = "";
            let af = undefined;
            if (studenttask.DeliveryFiles[0]) {
              afurl = studenttask.DeliveryFiles[0].WopiUrl;
              af = studenttask.DeliveryFiles[0];
            }
  
            this.setState({
              studenttask: studenttask,
              selectedfiles: studenttask.DeliveryFiles,
              activefile: af,
              activefileurl: afurl,
            });
              
          }
          catch (error) {
  
          }
          finally {
            this.setState({fileBeingDeleted: null});
          }
        }
      }}
    >
      Slett fil
    </ActionButton> : 
    <Spinner style={{marginLeft: "1.5em"}}
      size={SpinnerSize.medium}
    ></Spinner>    
  }

  render() {
    const { id } = this.props.match.params;
    if (this.props.activefile && !this.state.activefile) {
      this.setState({ activefile: this.props.activefile });
    }
    if (!this.props.studenttask || !this.props.studenttask.Id) {
      return <div>laster</div>;
    }
    if (
      this.props.studenttask &&
      this.props.studenttask.Id &&
      id != this.props.studenttask.Id
    ) {
      return <div>laster ny innlevering</div>;
    }
    if (!this.state.downloading) {
      return <div>laster</div>;
    }
    if (this.state.studenttask) {
      let emptylist = JSON.parse(
        JSON.stringify(this.props.studenttask.DeliveryFiles)
      );
      emptylist.forEach((element) => {
        element.UrkundOptOutMessage = null;
      });
      let dstatus = "";
      switch (this.props.studenttask.DeliveryStatus) {
        case 1:
          dstatus = "Utlevert";
          break;
        case 0:
          dstatus = "Levert";
          break;
        case 2:
          dstatus = "Rettet";
          break;
        default:
          break;
      }

      if (this.props.studenttask.DeliveryStatus == 1 && !this.hasTaskStarted()) {
        dstatus = "Låst"
      }

      return (
        <div className="ms-Grid">
          <div className="main">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-lg3">
                <div className="header">
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col">
                      <h1 className="">
                        {" "}
                        <i className="ms-Icon ms-Icon--CompletedSolid"></i>{" "}
                        Innlevering
                      </h1>
                      <h2 className=" zSubTitle ms-font-l">
                        <b>Oppgave:</b> {this.props.studenttask.WsTask.Name}
                      </h2>
                      {this.props.studenttask.WsTask.Starttime &&
                        <h2 className=" zSubTitle ms-font-l">
                            <b>Starttidspunkt:</b>{" "}
                            {moment(this.props.studenttask.WsTask.Starttime).format("DD.MM.YYYY HH:mm")}
                        </h2>
                      }
                      <h2 className=" zSubTitle ms-font-l">
                        <b>Frist:</b>{" "}
                        {this.props.studenttask.WsTask.Deadlinetekst}.{" "}
                      </h2>
                      {this.state.studenttask.WsTask && this.state.studenttask.WsTask.DeliverAfterDeadline && <h2 className=" zSubTitle ms-font-l">
                        Levering etter fristen
                      </h2>}
                      {this.state.studenttask.WsTask && this.state.studenttask.WsTask.KeepOpen && <h2 className=" zSubTitle ms-font-l">
                        Flere forsøk
                      </h2>}
                    </div>
                  </div>
                </div>
              </div>
              <div className="ms-Grid-col ms-lg9">
                <div className="ms-Grid-col ms-sm12 ms-md6 text-left ms-fontColor-black studentTaskTopCol">
                  {
                    this.props.studenttask.WsTask.Text && this.props.studenttask.WsTask.Text.length>0 &&
                    <h4 className=" ms-fontColor-black">Oppgavetekst</h4>
                  }
                 
                  <p>
                    <span className="remove-para-margin"
                      dangerouslySetInnerHTML={{
                        __html: this.props.studenttask.WsTask.Text,
                      }}
                    ></span>
                    {this.props.studenttask.WsTask.Link &&
                      this.props.studenttask.WsTask.Link.length > 0 && (
                        <a href={this.props.studenttask.WsTask.Link}>
                          {this.props.studenttask.WsTask.Link}
                        </a>
                      )}
                  </p>
                  <p>
                    <ul>
                      {this.state.studenttask.WsTask.TaskFiles &&
                        this.state.studenttask.WsTask.TaskFiles.map((taskF) => {
                          return (
                            <li>
                              <a href={taskF.FileUrl} target="_blank">
                                {taskF.FileName}
                              </a>
                            </li>
                          );
                        })}
                    </ul>
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-fontColor-black studentTaskTopCol">
                  {
                    this.state.studenttask.WsTask.GrepCodeList && this.state.studenttask.WsTask.GrepCodeList.length >0 &&
                    <h4 className=" ms-fontColor-black">Kompetansemål</h4>
                  }
                  
                  <p>
                    <ul className="grep-list">
                      {this.state.studenttask.WsTask.GrepCodeList.map((grp) => {
                        return (
                          <li style={{cursor: 'pointer'}}>
                            <a href={grp.DetailUrl} target="_blank">
                              {grp.GrepTekst}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </p>
                </div>
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <div className="ms-Grid-row ms-bgColor-neutralLight topTool">
       
                  <div>
                    <div className="ms-font-l" style={{textAlign: 'right', padding: 5, marginRight: 60}}>
                    {
                      dstatus && dstatus.length>0 &&
                      <span style={{marginRight: 10}} className="ms-fontWeight-semibold"> Status:</span>
                    }
                     
                       {(dstatus === "Rettet" && !this.props.studenttask.ShowEval) ? "Levert" : dstatus} 

                       {!this.wasDeliveredOnTime() && <span style={{textAlign: "center"}}>
                        <Icon data-tip data-for='lateDelivery' iconName="Clock" style={{fontSize: 16 , marginLeft: 5, color: "red", cursor: "default"}}/>
                        <ReactTooltip id="lateDelivery">
                          <p style={{fontSize: 15}}>Denne besvarelsen ble levert etter fristen</p>
                          <p>{moment(this.props.studenttask.DateDelivered).format("HH:mm DD.MM.yyyy")}</p>
                        </ReactTooltip>
                      </span>}

                    </div>
                  </div>
                  <div className="ms-Grid-row topToolSub">
                    <div className="ms-Grid-col ms-sm10">
                        {this.props.studenttask.ShowEval &&
                          this.state.studenttask.DeliveryStatus !== 1 &&
                        <div id="gradedBlock">
                          <div className="ms-Grid-col ms-sm6">
                            <div className="ms-font-m ms-fontWeight-semibold">
                              Vurdering fra lærer
                            </div>
                            <span className="remove-para-margin ql-editor" style={{backgroundColor: "transparent"}}
                              dangerouslySetInnerHTML={{
                                __html: this.props.studenttask
                                  .GradingCommentDisplay,
                              }}
                            ></span>
                          </div>
                          <div className="ms-Grid-col ms-sm6">
                            <div className="ms-font-m ms-fontWeight-semibold">
                              Karakter
                            </div>
                            {this.props.studenttask.Grade}{" "}
                            {this.props.studenttask.GradeModifier}
                          </div>
                          {this.state.studenttask.Uipkms && this.state.studenttask.Uipkms.length > 0 &&
                              <div className="ms-Grid-col ms-sm12">
                                <div className="uip-row">
                                  <Label>
                                    <div className="ms-font-m ms-fontWeight-semibold">Grad av måloppnåelse</div>
                                  </Label>
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th className="iup-table-header-first">
                                            <div className="ms-font-m ms-fontWeight-semibold">
                                              Kompetansemål
                                            </div>
                                          </th>
                                          <th className="iup-table-header-second">
                                            <div className="ms-font-m ms-fontWeight-semibold">
                                              Måloppnåelse
                                            </div>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.studenttask.Uipkms.map(
                                            (uip) => {
                                              return (
                                                <tr className="kmrow uipitem">
                                                  <td
                                                    data-lpid="@uip.Lpid"
                                                    data-kmid="@uip.Kmid"
                                                    className="kmtext"
                                                  >
                                                    {uip.Kmtext}
                                                  </td>
                                                  <td>
                                                    <div className="ms-ChoiceFieldGroup">
                                                      {uip.Eval ==
                                                        "1" && (
                                                        <div className="ms-ChoiceField">
                                                          <i
                                                            className="ms-Icon ms-Icon--TestBeaker"
                                                            aria-hidden="true"
                                                          ></i>{" "}
                                                          Lav
                                                        </div>
                                                      )}
                                                      {uip.Eval ==
                                                        "2" && (
                                                        <div className="ms-ChoiceField">
                                                          <i
                                                            className="ms-Icon ms-Icon--TestBeakerSolid"
                                                            aria-hidden="true"
                                                          ></i>{" "}
                                                          Middels
                                                        </div>
                                                      )}
                                                      {uip.Eval ==
                                                        "3" && (
                                                        <div className="ms-ChoiceField">
                                                          <i
                                                            className="ms-Icon ms-Icon--TestCase"
                                                            aria-hidden="true"
                                                          ></i>{" "}
                                                          Høy
                                                        </div>
                                                      )}
                                                    </div>
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                          }                          
                          <div className="ms-Grid-col ms-sm12 ms-md12">
                            {this.props.studenttask.ShowEval && this.state.studenttask.DeliveryStatus !== 1 && 
                              <EvaluationFiles
                                Task={this.state.studenttask}
                                CanBeEdited={false}
                                SemiBoldTitle
                                isLoadingFiles={this.state.isLoadingEvaluationFiles}
                                filesToUpload={this.state.evaluationFilesToUpload}
                                evaluationFiles={this.state.evaluationFiles}
                                filesLoading={this.state.evaluationFilesLoading}
                                errorFetchingFiles={this.state.errorFetchingEvaluationFiles}
                                fetchEvaluationFiles={this.fetchEvaluationFiles}
                              />
                            }
                          </div>
                          
                        </div>
                        }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            { this.hasTaskStarted() ?
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 ms-xl10">
                <div className="studentResources">
                  {this.state.activefile &&
                    this.canEdit() && (
                      <ActionButton
                        disabled={!this.state.activefile || this.fileIsBeingDeleted(this.state.activefile.Id) || this.state.activefile.IsUploadedFile || this.state.delivering}
                        iconProps={{ iconName: "Edit" }}
                        style={{fontSize: '15px', border: '1px solid #444'}}
                        onClick={() => {
                          window.open(
                            this.state.activefile.WopiViewUrl,
                            "_blank"
                          );
                        }}
                      >
                        Skriv mer på filen
                        
                      </ActionButton>
                    )}
                    <div>
                      <UploadFileForm
                        enableDeviceUpload={this.canUploadFiles()}
                        enableOneDrivePicker={this.canUploadOneDriveFiles()}
                        enableFilePreview={!EXAM_MODE}
                        // enableDeviceUpload={true}
                        // enableOneDrivePicker={true}
                        CanBeEdited={this.canEdit()}
                        uploadedFiles={this.state.selectedfiles}
                        isLoadingFiles={false}
                        filesLoading={this.state.dfFilesLoading}
                        errorFetchingFiles={false}
                        onUploadedFileSelect={(item) => {
                          this.setState({ activefile: item });
                        }}
                        deleteUploadedFile={async (file) => {
                          // Implement delete logic here
                          this.setState({ dfFilesLoading: [...this.state.dfFilesLoading, file.FileUniqueId], isLoadingDeliveryFiles: true });
                          await this.props.removeDeliveryFile(file);

                          const ret = await this.props.getStudentTaskDeliver(this.state.studenttask);
                          console.log(ret);
                          let studenttask = ret.payload.data;
                          let afurl = "";
                          let af = undefined;
                          if (studenttask.DeliveryFiles[0]) {
                            afurl = studenttask.DeliveryFiles[0].WopiUrl;
                            af = studenttask.DeliveryFiles[0];
                          }
                
                          this.setState({
                            studenttask: studenttask,
                            selectedfiles: studenttask.DeliveryFiles,
                            activefile: af,
                            activefileurl: afurl,
                            dfFilesLoading: this.state.dfFilesLoading.filter(id => id !== file.FileUniqueId),
                            isLoadingDeliveryFiles: false
                          });
                        }}
                        submitFiles={async (files) => {
                          // Implement submit logic here
                          this.setState({ isLoadingDeliveryFiles: true, dfFilesLoading: [...this.state.dfFilesLoading, ...files.map(f => f.name)] });
                          const result = await uploadTaskFiles(this.state.studenttask.Id, files);

                          let newSelectedFiles = [...this.state.selectedfiles];
                          result.forEach((res) => {
                            if (!newSelectedFiles.some(f => f.Id === res.Id)) {
                              newSelectedFiles.push(res);
                            }
                          });
                          this.state.studenttask.DeliveryFiles = newSelectedFiles;

                          this.setState({ studenttask: this.state.studenttask, selectedfiles: newSelectedFiles, isLoadingDeliveryFiles: false, dfFilesLoading: this.state.dfFilesLoading.filter(id => !files.map(f => f.name).includes(id)) });
                          
                        }}
                        onOneDriveSelect={(selected) => {
                          const draft =
                            selected.OriginalDocumentID +
                            "|" +
                            selected.FileName +
                            "|" +
                            selected.GraphParentDriveId +
                            "|" +
                            selected.GraphItemId;
                          this.props.addDeliveryFile({
                              Draft: draft,
                              StudentTaskID: this.props.studenttask.Id,
                            }).then((ret) => {
                              console.log("added file", ret);
                              this.props.getStudentTaskDeliver(this.state.studenttask)
                              .then((ret) => {
                                  console.log("hentet på nytt", ret);
                                  let studenttask = ret.payload.data;
                                  let afurl = "";
                                  let af = undefined;
                                  if (studenttask.DeliveryFiles[0]) {
                                    afurl = studenttask.DeliveryFiles[0].WopiUrl;
                                    af = studenttask.DeliveryFiles[0];
                                  }
                                  this.setState({
                                    studenttask: studenttask,
                                    selectedfiles: studenttask.DeliveryFiles,
                                    activefile: af,
                                    activefileurl: afurl,
                                  });
                                });
                            })
                        }}
                      />
                    </div>
                  {/* )} */}
                  {console.log(this.state.delivering)}
                {this.state.delivering && (
                  <ProgressList
                    finished={() => {
                      console.log("gotfinishmessage");
                      this.props.history.push("/innleveringerstudent");
                    }}
                    currenttask={this.state.studenttask}
                  ></ProgressList>
                )}
                  {!EXAM_MODE && <div id="linkadds">
                    {this.canEdit() && this.canUploadLinks() ?
                        <LinkForm
                        />
                        : <div>{this.state.studenttask.LinksCollection && this.state.studenttask.LinksCollection.length > 0 && 
                          <div>
                            <Label style={{ fontWeight: "bold" }}>
                              Innleverte lenker
                            </Label>
                            <ul id="addedlinks">
                              {this.state.studenttask.LinksCollection.map(
                                (link) => {
                                  return (
                                    <li className="addedlink">
                                      <a target="_blank" href={this.formatExternalLink(link)}>
                                        {link}
                                      </a>
                                    </li>
                                  );
                                }
                              )}
                            </ul>
                          </div>
                          }
                      </div>
                    }
                  </div>}

                  <div className="ms-ChoiceFieldGroup mt-20">
                      {this.canEdit() && 
                          <PrimaryButton
                            disabled={this.state.delivering || this.state.dfFilesLoading?.length > 0}
                          style={{marginTop: "25px"}}
                          onClick={() => {
                            console.log(
                              "trigger baby",
                              this.state.studenttask.DeliveryFiles
                            );
                            this.setState({ delivering: true }, () => {
                              this.props.initStatusTask(emptylist);
                              this.props
                                .submitTask(this.state.studenttask)
                                .then((resp) => {
                                  console.log("resp submitTask", resp);
                                  this.props.checkStatusTask(resp.payload.data);
                                });
                            });
                          }}
                        >
                          Send inn
                        </PrimaryButton>
                      }
                    
                      <div className="ms-Grid-row" style={{marginTop: 20}}>
                          <div className="ms-Grid-col ms-sm12 ms-md12">
                        {this.state.activefile && (
                          <Select
                            placeholder={"Versjoner"}
                            onChange={(selected) => {
                              window.open(selected.value, "_blank");
                            }}
                            options={this.state.activefile.opts}
                          />
                        )}
                        </div>
                    </div>

                  <ul>
                    {this.state.comments.map((item) => {
                      return (
                      <div className="mt-10">
                        <Label style={{fontWeight:'bold'}}>Kommentarer fra lærer</Label>
                        <li>
                          <span style={{fontWeight:'bold'}}> {item.TeacherName}</span> la
                          inn kommentar den <b>{item.Datefriendly}</b>:
                          <div style={{padding:10}}>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: item.CommentText,
                              }}
                            ></span>
                          </div>
                        </li>
                        </div>
                      );
                    })}
                  </ul>
                  </div>
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12  text-left">
                  {
                    this.state.studenttask.DeliveryStatus !== 4 && this.state.activefile &&
                    (<div className="oppgavePreviewCont">
                    <span className="ms-fontSize-xl">
                      Forhåndsvisning av{" "}
                      <a className="ms-Link" href={this.state.activefile.WopiViewUrl || this.state.activefile.FileUrlDelivery} target="_blank">
                        {this.state.activefile &&
                          this.state.activefile.StudentTaskID == id && (
                            <span>{this.state.activefile.FileNameDraft}</span>
                          )}
                      </a>
                    </span>
                    {this.state.studenttask.WsTask.KeepOpen && this.state.activefile &&
                      this.state.activefile.StudentTaskID == id &&
                      (
                          <iframe
                            height="800px"
                            className="oppgavePreview"
                            id="wopiFrame"
                            src={this.state.activefile.WopiUrl}
                          ></iframe>
                      )}
                    {!this.state.studenttask.WsTask.KeepOpen && this.state.activefile &&
                      this.state.activefile.StudentTaskID == id &&
                      (this.state.studenttask.DeliveryStatus == 1 || this.state.studenttask.DeliveryStatus == 6) && (
                          <iframe
                            height="800px"
                            className="oppgavePreview"
                            id="wopiFrame"
                            src={this.state.activefile.WopiUrl}
                          ></iframe>
                      )}
                      {!this.state.studenttask.WsTask.KeepOpen && this.state.activefile &&
                      this.state.activefile.StudentTaskID == id &&
                      (this.state.studenttask.DeliveryStatus != 1 && this.state.studenttask.DeliveryStatus != 6) && (
                          <iframe
                            height="800px"
                            className="oppgavePreview"
                            id="wopiFrame"
                            src={
                              this.state.activefile.WopiUrl
                            }
                          ></iframe>
                      )}
                  </div>)

                  }
                </div>
              </div>
            </div>
              : this.renderTaskNotStarted()
            }
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  // let afurl = "";
  // let af = undefined;
  // if (
  //   state.StudentReducer.studenttask &&
  //   state.StudentReducer.studenttask.DeliveryFiles
  // ) {
  //   state.StudentReducer.studenttask.DeliveryFiles.forEach((element) => {
  //     let veropt = [];
  //     if (element.VersionFiles) {
  //       element.VersionFiles.forEach((element) => {
  //         veropt.push({ value: element.WopiUrl, label: element.Name });
  //       });
  //     }

  //     element.opts = veropt;
  //   });
  //   if (state.StudentReducer.studenttask.DeliveryFiles[0]) {
  //     afurl = state.StudentReducer.studenttask.DeliveryFiles[0].WopiUrl;
  //     af = state.StudentReducer.studenttask.DeliveryFiles[0];
  //   }
  // }
  return {
    teacherstate: state.teacher,
    studenttask: state.StudentReducer.studenttask,
    // activefileurl: afurl,
    // activefile: af,
  };
}

export default connect(mapStateToProps, {
  getStudentTaskDeliver,
  addDeliveryFile,
  submitTask,
  checkStatusTask,
  initStatusTask,
  removeDeliveryFile,
  getComments,
})(StudentTaskView);
